var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"pointer",style:(("margin-left: " + _vm.deep + "rem; margin-right: 3px;")),on:{"click":_vm.handleClick}},[(_vm.hasItems)?_c('i',{staticClass:"fas",class:_vm.expanded ? 'fa-chevron-down' : 'fa-chevron-right'}):_vm._e()])}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-86665cf2","hasScoped":false,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/treegrid/TreeGridExpandButton.vue
// module id = null
// module chunks = 